import QRCode from 'qrcode'

/** An SVG QR code for `url`, dark on a white quiet zone so phone cameras read it on any theme. */
export function qrCodeSvg(url: string): Promise<string> {
    return QRCode.toString(url, {
        type: 'svg',
        color: {
            dark: '#111111',
            light: '#ffffff',
        },
        margin: 2,
        width: 128,
    })
}
